import { useVotes } from '../../context/VotesContext';
import styles from './VoteFullSize.module.css';
import classNames from 'classnames';

function wrapRanges(text) {
  const regex = /(\d+[-–‑]\d+%)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    parts.push(
      <span key={match.index} className={styles.nowrap}>
        {match[0]}
      </span>,
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  return parts;
}

const protocol = window?.location.protocol || 'https:';

export const VoteFullSize = ({ variants, title, idVote, authorId }) => {
  const { votes, setVote } = useVotes();

  const clickAnswer = async (item) => {
    if (votes[idVote]) {
      return;
    }

    const { name } = item;
    const content = JSON.parse(name)?.[0] || name;

    setVote(idVote, content);

    try {
      const response = await fetch(
        `${protocol}//wh.iactive.pro/api/getter/landing`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: content,
            authorId,
            date: Date.now(),
          }),
        },
      );
    } catch (error) {
      console.error('Ошибка запроса:', error);
      setVote(idVote, '');
    }
  };

  const coeff = title?.length < 160 ? 0.9 : title?.length < 185 ? 0.7 : 0.6;

  const getClassName = (item) => {
    const { name } = item;
    const content = JSON.parse(name)?.[0] || name;

    return classNames(styles.var, {
      [styles.isActiveVar]: votes[idVote] && content === votes[idVote],
    });
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.question}
        style={{
          fontSize: `${coeff * 24}px`,
        }}
      >
        {title}
      </div>
      <div className={styles.subTitle}>Выберите вариант</div>

      <div className={styles.vars}>
        {variants?.map((item, i) => {
          return (
            <button
              key={i}
              className={getClassName(item)}
              onClick={() => clickAnswer(item)}
            >
              <div className={styles.varNumber}>{i + 1}.</div>

              <div className={styles.varTitle}>{wrapRanges(item.comment)}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
